import { createServerErrorAsToastr } from 'common/server-errors-toastr';
import childOrganizationActions from 'packages/pages/admin-v2/child-organization/actions';
import Organizations from 'states/resources/organizations/actions';
/** import single application imports in the section above, Sort Lines Ascending */

const actions = {
    /**
     * Open the deprecate confirmation modal for a sidebar org row.
     * Pass the full organization so the modal can read id/name/client_type without a
     * hand-built context object (same pattern as deleteModalActions.open(user)).
     * userCount is taken from the child-org usersByOrgId cache at open time.
     *
     * @param {Object} organization - Org from organizationsForList (must include `id`)
     */
    open(organization) {
        return (dispatch, getState) => {
            const usersByOrgId = getState()?.adminV2?.childOrganization?.usersByOrgId ?? {};
            const orgUsers = organization?.id ? usersByOrgId[organization.id] : undefined;
            dispatch({
                type: 'DEPRECATE_ORG_MODAL__OPEN_MODAL',
                payload: {
                    organization: organization || null,
                    userCount: Array.isArray(orgUsers) ? orgUsers.length : 0,
                },
            });
        };
    },
    close() {
        return dispatch => {
            dispatch({
                type: 'DEPRECATE_ORG_MODAL__CLOSE_MODAL',
            });
        };
    },
    /**
     * PATCH deprecated:true, prune child-org cache locally, then close. Errors stay in-modal via toastr.
     */
    deprecate() {
        return async (dispatch, getState) => {
            const organizationId = getState()?.deprecateOrgModal?.organization?.id;

            if (!organizationId) {
                dispatch({
                    type: 'DEPRECATE_ORG_MODAL__DEPRECATE_FAIL',
                });
                dispatch(actions.close());
                return;
            }

            dispatch({
                type: 'DEPRECATE_ORG_MODAL__DEPRECATE_START',
            });
            try {
                await dispatch(Organizations.update(organizationId, { deprecated: true }));
                dispatch(childOrganizationActions.applyDeprecatedOrganization(organizationId));
                dispatch({
                    type: 'DEPRECATE_ORG_MODAL__DEPRECATE_SUCCESS',
                });
                dispatch(actions.close());
            } catch (error) {
                dispatch({
                    type: 'DEPRECATE_ORG_MODAL__DEPRECATE_FAIL',
                });
                createServerErrorAsToastr(error);
            }
        };
    },
};

export default actions;
